export default __webpack_public_path__ + "static/media/woman.16148197.jpg";